import { render, staticRenderFns } from "./addDataRule.vue?vue&type=template&id=09a134a2&scoped=true"
import script from "./addDataRule.vue?vue&type=script&lang=js"
export * from "./addDataRule.vue?vue&type=script&lang=js"
import style0 from "./addDataRule.vue?vue&type=style&index=0&id=09a134a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a134a2",
  null
  
)

export default component.exports